import { Card, CardLevel, Drawer, Heading2, Link, PaddingLevel } from '@pinpointhq/thumbtack';
import * as React from 'react';
import { visit } from 'turbolinks';
import { exportAdminAllocationRunPath } from '../../../javascript/application/ts_routes';
import { DrawerHeader } from '../../shared/DrawerHeader';

export function ShowDrawer({ allocationRun, handleClose }) {
  return (
    <Drawer maxWidth={800} isOpen={true} onClose={handleClose}>
      <DrawerHeader title="Allocation Run" handleClose={handleClose} />
      <Card paddingLevel={PaddingLevel.EXPANDED} level={CardLevel.NONE}>
        <Heading2>Output files</Heading2>
        {Object.keys(allocationRun.output).map((key) => {
          const handleLinkClick = () => {
            visit(exportAdminAllocationRunPath(allocationRun.id, { job_id: key }));
          };

          return (
            <div key={key}>
              <Link onClick={handleLinkClick}>{allocationRun.output[key].title}</Link>
            </div>
          );
        })}
      </Card>
    </Drawer>
  );
}
